import { suppliesDiscountIdFormat } from "@redotech/redo-marketplace-id";
import * as z from "zod";

/**
 * Validates a code against the merchant's active cart and applies it. Rejection
 * is reported in the result, not as an error, so the cart can explain itself.
 */
export const applySuppliesDiscountCode = {
  name: "applySuppliesDiscountCode" as const,
  input: z.object({ code: z.string().min(1) }),
  output: z.discriminatedUnion("applied", [
    z.object({
      applied: z.literal(true),
      suppliesDiscountId: suppliesDiscountIdFormat.schema,
      /** Optional merchant-facing copy; the title is internal and never sent. */
      storefrontMessage: z.string().nullish(),
      /** What it takes off the current cart, minor units. */
      amount: z.number(),
    }),
    z.object({ applied: z.literal(false), message: z.string() }),
  ]),
};
